// Aviso do resultado de uma ação (toast): o padrão obrigatório do v2, como o campos.js na validação e o botao.js no botão.
// O tipo vai no nome, para nenhuma tela avisar sem cor: avisarSucesso (verde, ✓), avisarErro (vermelho, ✕) e avisar
// (neutro, informação). Um cartão embaixo (acima da barra do celular; no computador, no canto direito), com a barrinha do
// tempo, o X e a pausa com o mouse ou o foco em cima. O HTML é o #toast do _LayoutV2.
const _ICONE = { ok: 'i-check-circle-fill', erro: 'i-x-circle-fill', info: 'i-info-circle' };
// O erro fica mais: pede uma ação da pessoa.
const _TEMPO = { ok: 5000, erro: 7000, info: 5000 };
let _temporizador = null;
let _fim = 0;
let _restante = 0;
let _focoAntes = null;

export const avisarSucesso = texto => _mostrar(texto, 'ok');
export const avisarErro = texto => _mostrar(texto, 'erro');
export const avisar = texto => _mostrar(texto, 'info');

function _mostrar(texto, tipo) {
    const toast = document.getElementById('toast');
    if (!toast || !texto) {
        return;
    }
    // Com um <dialog> modal aberto (cookies, sessão), o resto da página fica inerte e embaixo dele.
    const destino = document.querySelector('dialog[open]') || document.body;
    if (toast.parentElement !== destino) {
        destino.append(toast);
    }
    toast.dataset.tipo = tipo;
    toast.querySelector('.toast__ic use')?.setAttribute('href', `#${_ICONE[tipo]}`);
    toast.style.setProperty('--toast-tempo', `${_TEMPO[tipo]}ms`);
    // Esvazia antes: o mesmo texto duas vezes seguidas não seria lido de novo.
    const linha = toast.querySelector('.toast__t');
    linha.textContent = '';
    requestAnimationFrame(() => { linha.textContent = texto; });
    // A barrinha recomeça a cada aviso.
    const barra = toast.querySelector('.toast__barra');
    barra.style.animation = 'none';
    void barra.offsetWidth;
    barra.style.animation = '';
    toast.classList.remove('is-pausado');
    toast.classList.add('is-on');
    _agendar(_TEMPO[tipo]);
}

function _agendar(ms) {
    clearTimeout(_temporizador);
    _fim = Date.now() + ms;
    _temporizador = setTimeout(_esconder, ms);
}

function _esconder() {
    clearTimeout(_temporizador);
    document.getElementById('toast')?.classList.remove('is-on');
}

function _pausar(toast, pausar) {
    if (!toast.classList.contains('is-on') || toast.classList.contains('is-pausado') === pausar) {
        return;
    }
    toast.classList.toggle('is-pausado', pausar);
    if (pausar) {
        clearTimeout(_temporizador);
        _restante = Math.max(1000, _fim - Date.now());
    } else {
        _agendar(_restante);
    }
}

export function mostrarSessaoExpirada() {
    const janela = document.getElementById('v2-sessao');
    if (!janela) {
        window.location.reload();
        return;
    }

    if (!janela.open) {
        janela.showModal();
    }
}

export function iniciarAviso() {
    const toast = document.getElementById('toast');
    toast?.querySelector('.toast__x')?.addEventListener('click', () => {
        const voltar = toast.contains(document.activeElement) ? _focoAntes : null;
        _esconder();
        if (voltar?.isConnected) {
            voltar.focus();
        }
    });
    toast?.addEventListener('pointerenter', () => _pausar(toast, true));
    toast?.addEventListener('pointerleave', () => _pausar(toast, false));
    toast?.addEventListener('focusin', e => {
        if (!toast.contains(e.relatedTarget)) {
            _focoAntes = e.relatedTarget;
        }
        _pausar(toast, true);
    });
    toast?.addEventListener('focusout', () => _pausar(toast, false));
    document.getElementById('v2-sessao-recarregar')?.addEventListener('click', () => window.location.reload());
    // Sessão expirada só sai recarregando: o Esc não fecha.
    document.getElementById('v2-sessao')?.addEventListener('cancel', e => e.preventDefault());
}
